<template>
    <div v-if="recipe" :class="['showcase-window sticky', recipe.flavor]" ref="showcaseWindow">
        <div>
            <h2 v-html="recipe.title"></h2>
            <p
                class="showcase-window__flavor"
                v-html="getMainIngredients(recipe.filters, recipe.isBounce)"
            ></p>
            <p
                class="showcase-window__is-cocktail"
            >{{ (recipe.cocktail) ? "cocktail" : "mocktail" }}</p>
            <router-link :to="gotoRecipe(recipe.friendlyname)" target="_self">
                <button>{{ cta }}</button>
            </router-link>
            <router-view />
        </div>
    </div>
</template>

<script>
import mixologyData from "./../../../static/libs/mixology";

export default {
    name: "showcase-window",
    props: {
        recipe: {
            type: Object
        },
        cta: {
            type: String
        }
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        getMainIngredients: (filters, isBounce) => {
            const [flavor, ...rest] = filters;
            const bounceTM = isBounce ? "bubly bounce™ " : "";
            let alcoholList = rest
            const alcohol = () => {
              if(!rest.length) return ""
              if(!!rest.find(item => !!item.includes("Absolut®"))) {
                alcoholList = rest.filter(item => item !== "vodka")
              }
              return " + " + alcoholList.join(" + ").replace("®", "<sup>®</sup>");
            } 
            const addBubly = !isBounce ? "bubly" : "";
            return `${bounceTM}${flavor.replace(
                "bubly",
                ""
            )}${addBubly}${alcohol()}`;
        },
        gotoRecipe: name => {
            return `recipes?name=${name}`;
        },
        handleScroll(e) {
            const showcaseWindow = this.$refs.showcaseWindow;
            // console.log(showcaseWindow.children)
            const sticky = showcaseWindow.offsetTop;
            // (window.pageYOffset >= sticky  - 357 ) ? showcaseWindow.classList.add("sticky") : showcaseWindow.classList.remove("sticky");
            const mql = window.matchMedia("(min-width: 768px)");
            if (mql.matches) {
                if (window.pageYOffset < 219) {
                    showcaseWindow.style.marginTop =
                        358 - window.pageYOffset + "px";
                    showcaseWindow.style.height = `calc(100vh - ${358 - window.pageYOffset}px)`;
                } else {
                    showcaseWindow.style.marginTop = 138 + "px";
                    showcaseWindow.style.height = `calc(100vh - ${138}px)`;
                }
            } else {
                showcaseWindow.style.marginTop = "0";
                showcaseWindow.style.height = `0`;
            }
        },
        handleResize(e) {
            const showcaseWindow = this.$refs.showcaseWindow;
            const mql = window.matchMedia("(min-width: 768px)");
            if (mql.matches) {
                if (window.pageYOffset < 219) {
                    showcaseWindow.style.marginTop =
                        358 - window.pageYOffset + "px";
                    showcaseWindow.style.height = `calc(100vh - ${358 - window.pageYOffset}px)`;
                } else {
                    showcaseWindow.style.marginTop = 138 + "px";
                    showcaseWindow.style.height = `calc(100vh - ${138}px)`;
                }
            } else {
                showcaseWindow.style.marginTop = "0";
                showcaseWindow.style.height = `0`;
            }
        }
    }
};
</script>

<style lang="scss">
@import "./../../css-abstracts/_showcase.scss";

.showcase-window {
    display: none;
    float: left;
    width: 50%;
    margin-top: 0px;
    max-height: calc(100vh - 138px);
    background-repeat: no-repeat;
    background-position: top center, bottom center;
    background-size: contain, 100%;

    h2 {
        font-size: 2rem;
        margin: 0;
        margin-top: calc(-16vh - 5vw);
    }

    p {
        font-size: 1rem;
    }

    &__is-cocktail {
        margin-top: -15px;
    }

    button {
        background-color: #fff;
        height: 1.875rem;
        padding: 0 15px;
        border: none;
        border-radius: 1rem;
        cursor: pointer;

        &:hover {
            color: #fff;
        }
    }

    &.mobile {
        display: block;
        width: 100%;
        height: 0;
        overflow: hidden;
        transition: height 0.3s ease-in-out;

        h2 {
            margin-top: 2rem;
            font-size: 1.5rem;
        }

        &.open {
            height: 23rem !important;
        }
    }

    @media (max-height: 970px) {
        h2 {
            font-size: 2.5rem;
        }
        p {
            font-size: 1rem;
        }
    }

    @media (max-height: 870px) {
        h2 {
            font-size: 2rem;
        }
    }
    @media (max-height: 800px) {
        h2 {
            margin-top: calc(-10vh - 5vw);
        }
    }
    @media (max-height: 700px) {
        background-size: contain, 0%;
        h2 {
            margin-top: 0;
        }
    }

    @media (min-width: 375px) {
        h2 {
            font-size: 2rem;
        }
        p {
            font-size: 1.25rem;
        }
    }

    @media (min-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        height: calc(100vh - 358px);
        position: fixed;
        left: 0;
        top: 358px;
        margin-top: 358px;

        &.sticky {
            top: 0px;
        }

        &.mobile {
            display: none;
        }
    }
    @media (min-width: 1024px) {
        h2 {
            font-size: 3rem;
        }

        @media (max-height: 1090px) {
            h2 {
                font-size: 2.5rem;
            }
            p {
                font-size: 1rem;
            }
        }

        @media (max-height: 870px) {
            h2 {
                font-size: 2rem;
            }
        }
        @media (max-height: 800px) {
            h2 {
                margin-top: calc(-10vh - 5vw);
            }
        }
        @media (max-height: 700px) {
            background-size: contain, 0%;
            h2 {
                margin-top: 0;
            }
        }
    }
    @media (min-width: 1400px) {
        h2 {
            font-size: 3rem;
        }

        @media (max-height: 1090px) {
            h2 {
                font-size: 2.5rem;
                margin-top: calc(-10vh - 5vw);
            }
            p {
                font-size: 1rem;
            }
        }

        @media (max-height: 800px) {
            background-size: contain, 0%;
            h2 {
                margin-top: 0;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mixology/ShowcaseWindow.vue